<template>
  <div>
    <!-- 查询区 -->
    <ul class="search-btn">
      <li>
        <el-button
          type="primary"
          @click="importVisible = true"
        >
          批量导入
        </el-button>
        <template v-if="allTotalCount > 0">
          <el-button
            type="primary"
            @click="batchDistribution('auto')"
          >
            自动分配
          </el-button>
          <el-button
            type="primary"
            @click="manualBatchDistribution"
          >
            手动分配
          </el-button>
        </template>
      </li>
    </ul>
    <!-- 表格数据 -->
    <SpCardContent>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="(item, index) in tabList"
          :key="index"
          :label="item.label"
          :name="item.name"
        />

        <el-table
          ref="multipleTable"
          v-loading="loading"
          :data="list"
          :row-key="getRowKeys"
          @select="handleSelectionChange"
          @select-all="selectAll"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="50"
          />
          <el-table-column
            prop="name"
            label="客户姓名"
            width="100"
          />
          <el-table-column
            prop="address"
            label="通信地址"
            min-width="120"
          />
          <el-table-column
            prop="lat"
            label="位置信息"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.lat">已定位</span>
              <span v-else>未定位</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="register_store_name"
            label="注册门店"
            min-width="150"
          />
          <el-table-column
            prop="register_store_bn"
            label="注册门店编号"
            width="110"
          />
          <el-table-column
            label="已分配员工"
            width="100"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.salesperson_name }}</div>
              <div style="color: #999999">
                {{ scope.row.salesperson_store_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="分配状态"
            width="80"
          >
            <template slot-scope="scope">
              {{ distributionStatus[scope.row.distribution_status] }}
            </template>
          </el-table-column>
          <el-table-column
            label="添加状态"
            width="80"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.bind_status === 0"
                style="color: #999999"
              >待添加</span>
              <el-tag
                v-if="scope.row.bind_status === 1"
                type="success"
                size="mini"
                effect="dark"
              >
                已添加
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="bind_time_desc"
            label="添加时间"
            width="160"
          />
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.distribution_status === 1 && scope.row.bind_status === 0"
                type="text"
                size="small"
                @click="cancelBatchDistribution(scope.row)"
              >
                撤回
              </el-button>
              <el-button
                v-if="scope.row.distribution_status === 0 || scope.row.distribution_status === 2"
                type="text"
                size="small"
                @click="manualBatchDistribution(scope.row)"
              >
                分配
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="deleteItem(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="content-padded content-right"
          style="margin-top: 16px"
          background
          :current-page="params.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="params.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total_count"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-tabs>
    </SpCardContent>

    <!-- 批量导入 -->
    <SpBulkImport
      v-model="importVisible"
      file-type="member_potential"
      title="批量导入客户添加导购"
      @saveImportAction="saveImportAction"
    >
      <div>
        批量导入说明： <br>
        1、下载潜客信息模版文件<br>
        2、根据填写要求填写潜客数据，上传并导入文件，文件格式必须为xlsx<br>
        3、单次上传xlsx最大条目数（行数）为5000，超出请按文件分批上传<br>
        4、上传后系统将校验文件内容格式，如有误，需根据提示修改后重新上传
      </div>
    </SpBulkImport>

    <!-- 手动分配 -->
    <SpGuideSelect
      v-model="guideVisible"
      @selectGuide="selectGuide"
    />
  </div>
</template>

<script>
import {
  getPotentialCustomerList,
  deletePotentialCustomerList
} from '@/api/customer/potentialCustomer'
export default {
  data () {
    return {
      distributionStatus: {
        0: '未分配',
        1: '已分配',
        2: '分配失败'
      },
      tabList: [
        { name: '-1', label: '全部' },
        { name: '1', label: '已分配' },
        { name: '2', label: '未分配' },
        { name: '3', label: '已添加' },
        { name: '4', label: '未添加' }
      ],
      params: {
        page: 1,
        page_size: 20
      },
      activeName: '-1',
      list: [],
      total_count: 0,
      loading: false,
      importVisible: false,
      allTotalCount: 0,
      guideVisible: false,
      potentialMemberIds: []
    }
  },
  mounted () {
    this.getList('first')
  },
  methods: {
    // 换页可选择
    getRowKeys (row) {
      return row.potential_member_id
    },
    // 全选事件
    selectAll (val) {
      let ids = []
      val.forEach((v) => {
        ids.push(v.potential_member_id)
      })
      this.potentialMemberIds = ids
    },
    // table表格选择
    handleSelectionChange (val) {
      let ids = []
      val.forEach((v) => {
        ids.push(v.potential_member_id)
      })
      this.potentialMemberIds = ids
      console.log(this.potentialMemberIds, 'this.potentialMemberIds')
    },

    // 获取列表数据
    async getList (type) {
      this.loading = true
      const data = await getPotentialCustomerList(this.params).catch(() => {
        this.loading = false
      })
      if (data) {
        this.list = data.list
        this.total_count = data.total_count
        this.loading = false
        if (type === 'first') {
          this.allTotalCount = data.total_count
          this.handleClick({ name: '-1' })
        }
      }
    },
    // 列表点击切换tab
    handleClick (tab) {
      console.log(tab.name)
      this.activeName = tab.name
      switch (tab.name) {
        case '-1':
          this.params.bind_status = -1
          delete this.params.distribution_status
          break
        case '1':
          this.params.distribution_status = 1
          delete this.params.bind_status
          break
        case '2':
          this.params.distribution_status = 0
          delete this.params.bind_status
          break
        case '3':
          this.params.bind_status = 1
          delete this.params.distribution_status
          break
        case '4':
          this.params.bind_status = 0
          delete this.params.distribution_status
          break
        default:
          this.params.bind_status = -1
          delete this.params.distribution_status
          break
      }
      this.params.page = 1
      this.getList()
    },

    // 列表分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    },

    // 删除列表
    deleteItem (item) {
      let deleteIds = item.potential_member_id.toString()
      this.$confirm('确定删除此数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.submitDelete(deleteIds)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 删除操作
    async submitDelete (deleteIds) {
      const data = await deletePotentialCustomerList(deleteIds)
      if (data) {
        this.$message({
          type: 'success',
          message: '删除成功'
        })
        this.params.page = 1
        this.getList()
      }
    },

    // 确定导入
    saveImportAction () {
      this.params.page = 1
      this.getList('first')
    },

    // 分配
    async batchDistribution (type, salesperson, potentialMember) {
      const loading = this.$loading({
        lock: true,
        text: '匹配导购中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = { type }
      if (salesperson && salesperson.salesperson_id) {
        params.salesperson_id = salesperson.salesperson_id
      }
      if (this.potentialMemberIds.length > 0) {
        params.potential_member_ids = this.potentialMemberIds
      }
      if (potentialMember && potentialMember.potential_member_id) {
        params.potential_member_ids = [potentialMember.potential_member_id]
      }
      const data = await this.$api.customer.batchDistribution(params).catch(() => {
        loading.close()
        this.guideVisible = false
      })
      if (data) {
        let message = '匹配成功'
        if (type === 'cancel') {
          message = '撤回成功'
        }
        this.$message({
          message,
          type: 'success'
        })
        this.$refs.multipleTable.clearSelection()
        this.potentialMemberIds = []
        this.getList()
        loading.close()
        this.guideVisible = false
      }
    },
    // 手动分配
    manualBatchDistribution (potentialMember) {
      if (potentialMember && potentialMember.potential_member_id) {
        this.potentialMemberIds = [potentialMember.potential_member_id]
        this.guideVisible = true
      } else if (this.potentialMemberIds.length > 0) {
        this.guideVisible = true
      } else {
        this.$message.error('请至少勾选一个客户')
      }
    },

    // 手动选择导购
    selectGuide (salesperson) {
      this.batchDistribution('manual', salesperson)
    },

    // 撤回
    cancelBatchDistribution (potentialMember) {
      this.batchDistribution('cancel', null, potentialMember)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}
</style>
